import { isInIframe } from 'integrations/utils/isInIframe';
import { IframeIntegration } from 'integrations';
import { IViewPort } from 'interfaces/IViewPort';
import { staticClassNames } from 'constants/staticClassNames';
import { PIXEL_ROUNDING_OFFSET } from 'constants/constants';
import { onElementHeightChange } from 'integrations/utils/onElementHeightChange';
import { containerNames } from 'integrations/utils/heightManager';
import SessionStore from 'store/Session/Session.store';

export default class LayoutStore {
    static getCurrentHeight = () => LayoutStore.getHeight(window.innerHeight);

    static getHeight = (height: number) => Math.max(height, 500);

    private isInIframe = isInIframe();

    private dynamicHeight: boolean;

    private modalCount = 0;

    private previousViewPort: IViewPort = {
        width: window.innerWidth,
        height: LayoutStore.getCurrentHeight(),
        iFrameTopOffset: 0,
        scrollY: 0,
    };

    private viewPort: IViewPort = {
        width: window.innerWidth,
        height: LayoutStore.getCurrentHeight(),
        iFrameTopOffset: 0,
        scrollY: 0,
    };

    public getViewPort = () => {
        if (!this.isInIframe) {
            return Promise.resolve(this.viewPort);
        }

        this.previousViewPort = {
            ...this.viewPort,
            height: LayoutStore.getCurrentHeight(),
        };

        return IframeIntegration.getViewPort().then((viewPort) => {
            this.viewPort = viewPort;

            return viewPort;
        });
    };

    public init = (sessionStore: SessionStore) => {
        this.dynamicHeight = this.isInIframe && sessionStore.dynamicHeight;

        if (!this.dynamicHeight) {
            document.body.classList.add(staticClassNames.STANDALONE);

            return;
        }

        onElementHeightChange(document.body, () => {
            IframeIntegration.getHeightManager().addOrUpdate({
                name: containerNames.BODY,
                height: document.body.offsetHeight + PIXEL_ROUNDING_OFFSET,
            });

            if (!document.body.classList.contains(staticClassNames.FIXED)) {
                IframeIntegration.updateHeight();
            } else {
                // In case BO list closed while betslip is visible - we need to update last height in the background
                this.previousViewPort.height = document.body.offsetHeight + PIXEL_ROUNDING_OFFSET;
                this.viewPort.scrollY = this.viewPort.iFrameTopOffset;
            }
        });

        IframeIntegration.updateHeight();

        IframeIntegration.getHeightManager().addOrUpdate({
            name: containerNames.BODY,
            height: document.body.offsetHeight + PIXEL_ROUNDING_OFFSET,
        });

        this.getViewPort();
    };

    public onOpenModal = () => {
        if (!this.dynamicHeight) {
            return;
        }

        if (this.modalCount === 0) {
            this.getViewPort().then((viewPort) => {
                IframeIntegration.scrollToPosition(viewPort.iFrameTopOffset);

                IframeIntegration.sendNewHeight(viewPort.height);

                document.body.classList.add(staticClassNames.FIXED);
            });
        }

        this.modalCount++;
    };

    public onCloseModal = () => {
        if (!this.dynamicHeight) {
            return;
        }

        this.modalCount--;

        if (this.modalCount === 0) {
            document.body.classList.remove(staticClassNames.FIXED);

            IframeIntegration.sendNewHeight(this.previousViewPort.height);

            window.setTimeout(() => {
                IframeIntegration.scrollToPosition(this.viewPort.scrollY);
            }, 50);
        }
    };
}
